/** @jsxImportSource @emotion/react */
import {
  Card,
  Icon,
  IconName,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';

interface Props {
  title: string;
  icon: IconName;
  amount: string;
}

export const AmountDisplay = ({ amount, title, icon }: Props) => {
  const { spacing, palette } = useTheme();
  return (
    <Card>
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.xxxs,
          marginBottom: spacing.xxxs,
        }}
      >
        <Icon name={icon} />
        <Typography variant="captionMedium" color={palette.grey.default}>
          {title}
        </Typography>
      </div>
      <Typography variant="heading1">{amount}</Typography>
    </Card>
  );
};
